import { faArrowUpRightFromSquare } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Link } from 'react-router-dom'
import { scrollToId } from '../../theme/utils'
import type { Album } from '../../types/portfolio'
import { ImagePreloader } from '../ImagePreloader'
import PlayButton from './components/PlayButton'
import { StreamingLinks } from './components/StreamingLinks'

export default function PortfolioCard({ item }: { item: Album }) {
  const className =
    'aspect-square h-full w-full object-cover transition duration-300 group-hover:scale-[1.02]'
  const genreText = (item.genre ?? []).map((g) => g.genre).join(', ')
  return (
    <article
      className="flex flex-col overflow-hidden rounded-xl border border-neutral-200 bg-white shadow-sm transition-shadow hover:shadow-md dark:border-neutral-700 dark:bg-neutral-800/80"
      data-aos="fade-up"
    >
      <div className="relative">
        <ImagePreloader
          src={item.image}
          alt={item.title}
          className={className}
          loading="lazy"
          decoding="async"
          width={365}
          height={365}
        />
        {/* <div className="pointer-events-none absolute inset-0 bg-linear-to-t from-black/5 to-transparent opacity-0 transition group-hover:opacity-100" /> */}
        <div className="pointer-events-none absolute inset-0 flex items-center justify-center">
          {item.songs && item.songs.length > 0 && (
            <div className="pointer-events-auto hidden lg:block">
              <PlayButton albumId={item.id} />
            </div>
          )}
          <div className="pointer-events-auto lg:hidden">
            <Link
              to={`/${item.slug}`}
              className="absolute bottom-2.5 right-2.5 z-10 rounded-lg bg-neutral-200 p-3 hover:bg-neutral-300 dark:bg-neutral-700 dark:hover:bg-neutral-600"
              onClick={() => {
                scrollToId('work')
              }}
            >
              <FontAwesomeIcon size="lg" icon={faArrowUpRightFromSquare} />
            </Link>
          </div>
        </div>
      </div>

      <div className="p-3 pt-0">
        <div className="mt-3 grid grid-cols-5 gap-2">
          <div className="col-span-4">
            <h3 className="text-lg font-semibold leading-tight">
              {item.title}
            </h3>

            <p className="text-sm mt-1 leading-snug text-neutral-500 dark:text-neutral-400">
              {item.artist} · {item.releaseYear}
              {genreText && <> · {genreText}</>}
            </p>
          </div>
          <div className="col-span-1 hidden items-center justify-end lg:flex">
            <Link
              to={`/${item.slug}`}
              className="group relative block rounded-lg border border-neutral-200 bg-neutral-100 p-2.5 transition-colors hover:border-neutral-300 hover:bg-neutral-200 dark:border-neutral-600 dark:bg-neutral-700 dark:hover:border-neutral-500 dark:hover:bg-neutral-600"
            >
              <FontAwesomeIcon size="lg" icon={faArrowUpRightFromSquare} />
            </Link>
          </div>
        </div>
        {item.links.length > 0 && (
          <div className="mt-3 hidden border-t border-neutral-100 pt-2 dark:border-neutral-700 lg:block">
            <StreamingLinks links={item.links} />
          </div>
        )}
      </div>
    </article>
  )
}
